import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import Clustering from './Clustering.js';
import GeoJSON from './GeoJSON.js';
import Controls from './Controls.js';
import Popups from './Popups.js';
import DebugMode from './DebugMode.js';

class Map {
    constructor() {
        if (Map.instance) return Map.instance;
        this.container = document.querySelector('.location-map-container');
        const markerUrlPrefix = window.location.origin + '/wp-content/themes/klaarnoord-theme/assets/img/';

        this.map = new maplibregl.Map({
            container: 'osm-map',
            style: 'https://maps.barreundmeyer.de/assets/styles/klaarnoord/colorful.json',
            center: [9.993682, 53.551086],
            zoom: 8,
            attributionControl: false,
            cooperativeGestures: true,
            locale: {
                'CooperativeGesturesHandler.WindowsHelpText': 'Verwenden Sie Strg + Scrollen, um die Karte zu vergrößern.',
                'CooperativeGesturesHandler.MacHelpText': 'Verwenden Sie ⌘ + Scrollen, um die Karte zu vergrößern.',
                'CooperativeGesturesHandler.MobileHelpText': 'Verwenden Sie zwei Finger, um die Karte zu verschieben.',
            },
        });

        // Add two custom marker icons, then load the actual map
        this.map.on('load', () => {
            Promise.all([
                this.map.loadImage(markerUrlPrefix + 'map-marker.png'),
                this.map.loadImage(markerUrlPrefix + 'map-marker-active.png'),
            ])
                .then(results => {
                    this.map.addImage('map-marker', results[0].data, { pixelRatio: 4 });
                    this.map.addImage('map-marker-active', results[1].data, { pixelRatio: 4 });
                })
                .then(() => {
                    this.initializeMap();
                })
                .catch(console.error);
        });

        if(this.container) {
            document.addEventListener('apiDataFetched', (data) => {
                this.updateMap(data.detail);
            });
        }

        Map.instance = this;
    }

    initializeMap() {
        new Controls(this.map);
        new Popups(this.map);
        new DebugMode(this.map);
    }

    updateMap(locations) {
        const geoJSON = new GeoJSON(this.map).parseDataFromLocations(locations, window.activeLocationId);

        // Add GeoJSON source (mandatory for clustering)
        if (!this.map.getSource('locations')) {
            this.map.addSource('locations', {
                type: 'geojson',
                data: geoJSON,
                cluster: true,
                clusterMaxZoom: 14,
                clusterRadius: 50
            });

            // Layer neccessary for actually rendering the markers
            this.map.addLayer({
                id: 'location-points',
                type: 'symbol',
                source: 'locations',
                layout: {
                    'icon-image':'map-marker',
                    'icon-size': 0.25,
                    'icon-anchor': 'bottom'
                }
            });
        } else {
            // Update already existing source
            this.map.getSource('locations').setData(geoJSON);
        }

        new Clustering(this.map);

        // Source should be set now, let's use it
        const source = this.map.getSource('locations');

        // Fly to active location (if we have one)
        if(window.activeLocationId) {
            const features = source._data.features;

            const activeLocation = features.find(
                feature => feature.properties.id === window.activeLocationId
            );

            this.map.flyTo({
                center: activeLocation.geometry.coordinates,
                zoom: 14,
                essential: true
            });
        } else {
            // Fit all markers on the map
            source.getBounds().then(bounds => {
                this.map.fitBounds(bounds, {
                    padding: 50,
                    maxZoom: 15,
                    duration: 1000
                });
            });
        }
    }
}

export default Map;
